export default [
    "s_guid",
    "s_mawb",
    "s_hawb",
    "s_tower",
    "s_level",
    "s_position",
    "s_location",
    "i_pieces",
    "s_unit",
    "s_airline_code",
    "s_flightnumber",
    "d_flight",
    "s_flight_uld",
    "t_modified",
    "s_modified_by",
    "s_location_type",
    "s_notes",
    "b_general_order",
    "b_comat", 
    "b_hold", 
    "b_usda_hold", 
    "b_customs_hold",
    "s_destination",
    "b_choice_skid"
];